<template>
  <div class="equipment-downtime-main">
    <div class="left-container">
      <div class="date-container" style=" max-width: 300px; padding: 5px;">
        <div style=" flex-grow: 1; ">
          <div style=" padding: 5px; ">Time</div>
          <DateTimePicker
            placeholder="From"
            :value.sync="startDate"
            :showTime="false"
          />
          <DateTimePicker
            placeholder="To"
            :value.sync="endDate"
            :showTime="false"
          />
        </div>
        <button @click="refreshClicked">Refresh</button>
      </div>

      <div class="filters" style=" max-width: 300px; height: 30%; padding:5px;">
        <Filters
          class="category-filter"
          title="Category"
          :tableData="categoryData"
          itemKey="CategoryDesc"
          itemDesc="CategoryDesc"
          @confirmClicked="filterCatConfirm"
          :selectedObject.sync="selectedCategory"
        />
        <Filters
          class="team-filter"
          title="Team"
          :tableData="teamData"
          itemKey="Description"
          itemDesc="Team"
          @confirmClicked="filterTeamConfirm"
          :selectedObject.sync="selectedTeam"
        />
        <Filters
          class="ownership-filter"
          title="Ownership"
          :tableData="ownershipData"
          itemKey="Ownership"
          itemDesc="Description"
          @confirmClicked="filterOwnershipConfirm"
          :selectedObject.sync="selectedOwnership"
        />
      </div>
    </div>

    <div class="right-container">
      <div class="top-bar">
        <div class="info-section">
          <div class="info-row">
            <div class="filter-title-long">Equipment Downtime</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">
              {{ this.fromDateInfo ? this.fromDateInfo : 'Start Date' }} to {{ this.toDateInfo ? this.toDateInfo : 'End Date' }}
            </div>
          </div>
          <div class="info-row">
            <div class="filter-title-long">Categories</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">
              {{
                this.selectedCategory == ""
                  ? "All"
                  : this.selectedCategoryPost.toString()
              }}
            </div>
          </div>
        </div>

        <div class="info-section">
          <div class="info-row">
            <div class="filter-title">Teams</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">
              {{
                this.selectedTeam == ""
                  ? "All"
                  : this.selectedTeamPost.toString()
              }}
            </div>
          </div>

          <div class="info-row">
            <div class="filter-title">Ownership</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">
              {{
                this.selectedOwnership == ""
                  ? "All"
                  : this.selectedOwnershipPost.toString()
              }}
            </div>
          </div>
        </div>

        <div class="refresh-section">
          <div v-if="!filterLoader">Last Refreshed : {{ refreshDate }}</div>
        </div>
      </div>

      <div class="chart-container">
        <div style=" font-weight:bold; ">
          Downtime Hours - Planned vs Unplanned
          <img
            class="interactable-chart-indicator"
            src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png"
            style=" height: 22px;
            width: 22px;
            position: absolute;
            top: 3px;
            right: 3px;"
          />
        </div>
        <div class="legend-holder" id="legend-holder"></div>

        <div class="chart-by-month" id="chart-by-month">
          <div class="barlinechart-table" id="barlinechart-table">
            <div class="month-hours-chart" id="month-hours-chart">
              <BarLineChart
                :data="byMonth"
                :contextMenus="[
                  'Planned Downtime details',
                  'Unplanned Downtime details',
                ]"
                @contextMenuClicked="drillThroughClicked"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="chart-container">
        <div style=" font-weight:bold; ">
          Downtime Hours by Equipment
          <img
            class="interactable-chart-indicator"
            src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png"
            style=" height: 22px;
            width: 22px;
            position: absolute;
            top: 3px;
            right: 3px;"
          />
        </div>
        <div class="chart-by-equipment" id="chart-by-equipment">
          <div class="barlinechart-table" id="barlinechart-table">
            <div class="equipment-hours-chart" id="equipment-hours-chart">
              <BarLineChart
                :data="byEquipment"
                :contextMenus="['Equipment Downtime Details']"
                @contextMenuClicked="drillThroughClicked"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function() {
    return {
      filterLoader: null,
      //input data
      startDate: null,
      endDate: null,
      refreshDate: this.$dateTime.getDateTime(new Date(), "yyyy-MM-dd HH:mm"),
      categoryData: [],
      selectedCategory: [],
      selectedCategoryPost: [],
      teamData: [],
      selectedTeam: [],
      selectedTeamPost: [],
      ownershipData: [],
      selectedOwnership: [],
      selectedOwnershipPost: [],

      //displayed data
      fromDateInfo: null,
      toDateInfo: null,
      displayCategory: "All",
      displayTeam: "All",
      displayOwnership: "All",

      //chart data
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      byMonth: [],
      byEquipment: [],
      chartBar: null,
      chartBar2: null,
    };
  },
  props: {},
  methods: {
    filterCatConfirm: function(items) {
      this.selectedCategory = items;
      this.selectedCategoryPost = items.map((a) => {
        return a["CategoryCode"];
      });
    },
    filterTeamConfirm: function(items) {
      this.selectedTeam = items;
      this.selectedTeamPost = items.map((a) => {
        return a["Team"];
      });
    },
    filterOwnershipConfirm: function(items) {
      this.selectedOwnership = items;
      this.selectedOwnershipPost = items.map((a) => {
        return a["Ownership"];
      });
    },
    refreshClicked: async function() {
      this.byMonth = [];
      this.byEquipment = [];
      this.refreshDate = this.$dateTime.getDateTime(
        new Date(),
        "yyyy-MM-dd HH:mm"
      );
      console.log('date clear: ',this.startDate);
      this.fromDateInfo = this.startDate ? this.$dateTime.getDateTime(this.startDate, "yyyy-MM-dd") : null;
      this.toDateInfo = this.endDate ? this.$dateTime.getDateTime(this.endDate, "yyyy-MM-dd") : null;
      
      if(this.startDate == null || this.endDate == null){
        this.$showAlert('warning', 'Date range not selected.', 'Please select start date and end date.')
      }

      //1st chart post
      let dataToPost1 = {
        category: this.selectedCategoryPost.toString(),
        ownership: this.selectedOwnershipPost.toString(),
        team: this.selectedTeamPost.toString(),
        startdate: this.fromDateInfo,
        enddate: this.toDateInfo,
        rpttype: "byMonth",
      };
      this.$fullscreenLoading("Getting Equipment Downtime");
      //MONTH DATA
      var monthly = await this.$apiCallV2(
        "/EquipmentDowntime/GetChart",
        dataToPost1
      );
      this.$fullscreenLoading();

      // if(monthly.length == 0){
      //   document.getElementById('month-hours-chart').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      // }else

      //segment for hours month chart
      let values = [];
      monthly.forEach((c) => {
        values = [];
        values.push({
          name: "Unplanned Hours",
          value: c["unplanned"],
          type: "bar",
        });
        values.push({
          name: "Planned Hours",
          value: c["planned"],
          type: "bar",
        });
        this.byMonth.push({
          name: `${c["currentYear"]} ${this.months[c["currentMonth"] - 1]}`,
          value: values,
        });
      });
      console.log("monthly data", JSON.stringify(this.byMonth));

      //2nd chart post
      let dataToPost2 = {
        category: this.selectedCategoryPost.toString(),
        ownership: this.selectedOwnershipPost.toString(),
        team: this.selectedTeamPost.toString(),
        startdate: this.fromDateInfo,
        enddate: this.toDateInfo,
        rpttype: "byEquipment",
      };
      this.$fullscreenLoading("Getting Equipment Downtime");
      //EQUIPMENT DATA
      var equipment = await this.$apiCallV2(
        "/EquipmentDowntime/GetChart",
        dataToPost2
      );
      console.log(equipment);
      this.$fullscreenLoading();

      // if(equipment.length == 0){
      //   document.getElementById('equipment-hours-chart').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      // }else
      // code segment for hours equipment segment
      equipment.forEach((c) => {
        values = [];
        values.push({
          name: "Downtime Hours: ",
          value: c["hours"],
          type: "bar",
        });
        this.byEquipment.push({ name: c["equipmentno"], value: values });
      });
      console.log("equipment data ", this.byEquipment);
    },
    clearFilters: function() {
      this.selectedCategory = "";
      this.selectedOwnership = "";
      this.selectedTeam = "";
    },

    drillThroughClicked: async function(item) {
      if (item.includes("Equipment Downtime Details")) {
        item = "Downtime Hours by Equipment";
        sessionStorage.setItem(
          `Drill Through - DETAILS ${item}`,
          JSON.stringify({
            category: this.selectedCategoryPost.toString(),
            ownership: this.selectedOwnershipPost.toString(),
            team: this.selectedTeamPost.toString(),
            startdate: this.fromDateInfo,
            enddate: this.toDateInfo,
            rpttype: "equipmentDrillThrough",
            refreshdate: this.refreshDate,
            title: item,
          })
        );

        var drillThroughLink = this.$router.resolve(
          `/Home/${
            this.$route["params"]["user"]
          }/Dashboard/Equipment Downtime/Drill Through - DETAILS ${item}`
        );
        window.open(drillThroughLink.href, "_blank");
        sessionStorage.clear();
      } else if (item.includes("Planned Downtime details")) {
        item = "Planned Downtime";
        sessionStorage.setItem(
          `Drill Through - DETAILS ${item}`,
          JSON.stringify({
            category: this.selectedCategoryPost.toString(),
            ownership: this.selectedOwnershipPost.toString(),
            team: this.selectedTeamPost.toString(),
            startdate: this.fromDateInfo,
            enddate: this.toDateInfo,
            rpttype: "plannedDrillThrough",
            refreshdate: this.refreshDate,
            title: item,
          })
        );

        var drillThroughLink = this.$router.resolve(
          `/Home/${
            this.$route["params"]["user"]
          }/Dashboard/Equipment Downtime/Drill Through - DETAILS ${item}`
        );
        window.open(drillThroughLink.href, "_blank");
        sessionStorage.clear();
      } else if (item.includes("Unplanned Downtime details")) {
        item = "Unplanned Downtime";
        sessionStorage.setItem(
          `Drill Through - DETAILS ${item}`,
          JSON.stringify({
            category: this.selectedCategoryPost.toString(),
            ownership: this.selectedOwnershipPost.toString(),
            team: this.selectedTeamPost.toString(),
            startdate: this.fromDateInfo,
            enddate: this.toDateInfo,
            rpttype: "unplannedDrillThrough",
            refreshdate: this.refreshDate,
            title: item,
          })
        );

        var drillThroughLink = this.$router.resolve(
          `/Home/${
            this.$route["params"]["user"]
          }/Dashboard/Equipment Downtime/Drill Through - DETAILS ${item}`
        );
        window.open(drillThroughLink.href, "_blank");
        sessionStorage.clear();
      } else console.log("nothing");
    },
  },
  async mounted() {
    this.$fullscreenLoading("Getting Details");
    this.categoryData = await this.$apiCallV2(
      `/EquipmentDowntime/GetVehicleCategory`
    );
    this.teamData = await this.$apiCallV2(
      `/EquipmentDowntime/GetListMaster?masterfile=team`
    );
    this.ownershipData = await this.$apiCallV2(
      `/EquipmentDowntime/GetListMaster?masterfile=vehicleownership`
    );
    var yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    this.startDate = yesterday;
    this.endDate = new Date();
    
    // (this.fromDateInfo = this.$dateTime.getDateTime(
    //   this.startDate,
    //   "yyyy-MM-dd"
    // )),
      (this.toDateInfo = this.$dateTime.getDateTime(
        this.endDate,
        "yyyy-MM-dd"
      )),
    this.refreshClicked();
    this.$fullscreenLoading();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/css/all.scss";

.equipment-downtime-main {
  display: flex;
  padding: 5px 5px 5px 45px;
  width: 100%;
  height: 100%;
  font-size: 12px;
  overflow-x: hidden;
  > .left-container {
    height: 100%;
    min-width: 300px;
    max-width: 300px;
    background-color: white;
    border-radius: 5px;
    margin-right: 5px;
    position: relative;

    > .date-container {
      height: 80px;
      display: flex;
      align-items: center;
      padding: 10px 5px 0 5px;
    }
  }

  > .right-container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;

    > .top-bar {
      width: 100%;
      height: auto;
      background-color: white;
      border-radius: 5px;
      position: -webkit-sticky;
      display: flex;
      align-items: center;
      margin-bottom: 3px;

      > .info-section {
        width: calc(100% - 250px);
        > .info-row {
          // padding: 2px;
          display: flex;
          align-items: center;
          > .filter-title-long {
            width: 270px;
            padding-left: 3px;
          }
          > .filter-title {
            width: 120px;
            padding-left: 3px;
          }
          > .colon-separator {
            margin: 0 5px;
          }
          > .filter-details {
            width: 100%;
          }
        }
      }
      > .refresh-section {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        white-space: nowrap;
        margin-right: 3px;
      }
    }

    > .chart-container {
      width: 100%;
      height: calc((100% - 45px) / 2);
      overflow: hidden;
      margin-bottom: 3px;
      background-color: white;
      border-radius: 5px;
      position: relative;

      .chart-by-month {
        width: 100%;
        height: 90%;
        display: flex;
        margin-bottom: 0px;
        padding-left: 3px;
        padding-right: 3px;
        padding-top: 5px;

        .barlinechart-table {
          width: 100%;
          height: 100%;
          position: relative;
          margin-top: -5px;
          overflow: auto;
        }
        .month-hours-chart {
          width: 100%;
          height: 100%;
          font-size: 10px;
        }
      }
      .legend-holder {
        white-space: nowrap;
        float: right;
        height: 20px;
        margin: 5px 15px 0px 0;
      }
      .chart-by-equipment {
        width: 100%;
        height: 100%;
        display: flex;
        margin-bottom: 0px;
        padding-left: 3px;
        padding-right: 3px;
        padding-top: 5px;
        .barlinechart-table {
          width: 100%;
          height: 100%;
          position: relative;
          margin-top: -5px;
          overflow-x: scroll;
        }
        .equipment-hours-chart {
          width: 100%;
          height: 100%;
          font-size: 10px;
          color: black;
        }
      }
    }
  }
}
</style>
